import { v4 as uuid } from 'uuid';
import { BatchInvoiceUploadCategory, Invoice } from '../../api/gql';

const relevantInvoiceCategoriesForUpload = [
  BatchInvoiceUploadCategory.New,
  BatchInvoiceUploadCategory.PartiallySettled,
  BatchInvoiceUploadCategory.Settled,
  BatchInvoiceUploadCategory.Ignored,
];

const relevantInvoiceCategoriesForContact = [BatchInvoiceUploadCategory.New];

export type XmlInvoiceType = Partial<Invoice> & {
  category: BatchInvoiceUploadCategory;
  name?: string;
};
export class XmlInvoice {
  #id: string;
  #details: XmlInvoiceType;
  #isForUpload: boolean;
  #isForContact: boolean;
  constructor(details: XmlInvoiceType) {
    this.#id = details.id || uuid();
    this.#details = details;
    this.#isForUpload = relevantInvoiceCategoriesForUpload.includes(details.category);
    this.#isForContact = relevantInvoiceCategoriesForContact.includes(details.category);
  }

  get id(): string {
    return this.#id;
  }
  set id(value: string) {
    this.#id = value;
  }
  get details() {
    return this.#details;
  }
  set details(details) {
    this.#details = details;
  }

  get category() {
    return this.details.category;
  }
  get isForUpload() {
    return this.#isForUpload;
  }
  get isForContact() {
    return this.#isForContact;
  }
}
